/**
 * OGカード（リンクを貼ったときのプレビュー）に使う、園ごとの実データ。
 *
 * 🟥 garden.ts の GARDEN_NAMES と同じ理由で、DBを待たずに正しい値を返せる
 *    静的な一覧にしてある（クローラーはJSを実行しないので、DB問い合わせを待てない）。
 *    外観写真は 2026-09-26 に 1600px・約200KBへ縮小した版（[[project_timee_ukeire_wizard_aoi]]）。
 *
 * 🟥 このファイルは2箇所から読まれる。
 *    1) src/lib/pageMeta.ts（ブラウザ内。タブの題名・共有カードをJSで整える）
 *    2) ルート直下の middleware.ts（Vercel Edge。クローラー向けに静的HTMLそのものを書き換える）
 *    園の写真を園設定画面で差し替えたら、ここも合わせて直す。
 */

import { GARDEN_NAMES } from './garden';

export type GardenOg = { name: string; image: string };

const B = 'https://adscvyckqhznzoxyjglc.supabase.co/storage/v1/object/public/garden-photos';

export const OG_FALLBACK_IMAGE = `${B}/common/kirari-logo.png`;

// 名前は garden.ts の GARDEN_NAMES が正本。ここは写真だけ持つ
export const OG_IMAGES: Record<string, string> = {
  kagano: `${B}/kagano/exterior_w1600.jpg`,
  minoh: `${B}/osaka-minoh/exterior_w1600.jpg`,
  sanuma: `${B}/sanuma/exterior_w1600.jpg`,
  'sendai-izumi': `${B}/sendai-izumi/exterior_w1600.jpg`,
  'sendai-rokuchome': `${B}/sendai-rokuchome/photo_exterior_url_1775287888514.jpg`,
  tagajo: `${B}/tagajo/exterior_w1600.jpg`,
};

export function slugFromHost(host: string): string {
  const m = host.match(/^([^.]+)-spot\./);
  return m ? m[1] : 'minoh';
}

export function getGardenOg(slug: string): GardenOg {
  return {
    name: GARDEN_NAMES[slug] ?? 'きらり保育園',
    image: OG_IMAGES[slug] ?? OG_FALLBACK_IMAGE,
  };
}
